import { useTheme, ThemeTypings } from "@chakra-ui/react";
import React from "react";

type IncentivesIllustrationProps = React.SVGProps<SVGSVGElement> & {
  colorScheme?: ThemeTypings["colorSchemes"];
  linesColor?: string;
};

const IncentivesIllustration = ({
  colorScheme = "primary",
  linesColor = "currentColor",
  ...rest
}: IncentivesIllustrationProps) => {
  const theme = useTheme();

  return (
    <svg
      width="145"
      height="63"
      viewBox="0 0 145 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#incentivesClipPath)">
        <path
          d="M0.100708 46.0449L27.122 6.06272L35.6131 27.6739L60.1897 0.725006L64.3991 11.5306L85.2147 1.66525L76.6079 42.66L106.378 10.4746L110.471 30.1764L145 6.06272L133.298 42.8915L122.665 28.8745L94.5304 53.5813L93.7493 44.3814L67.4658 62.275L54.0419 30.3211L0.100708 46.0449Z"
          fill={theme["colors"][colorScheme]["600"]}
        />
        <path
          d="M61.6467 14.6125L35.507 12.491L33.0016 43.3598L59.1413 45.4813L61.6467 14.6125Z"
          fill={theme["colors"][colorScheme]["500"]}
          stroke={linesColor}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M56.7696 17.2845L39.8862 15.9142C38.9625 15.8392 38.153 16.5272 38.078 17.4509L36.8318 32.806C36.7568 33.7297 37.4448 34.5393 38.3685 34.6142L55.2519 35.9845C56.1756 36.0595 56.9852 35.3714 57.0601 34.4478L58.3064 19.0927C58.3813 18.169 57.6933 17.3594 56.7696 17.2845Z"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M35.6132 38.8556L54.042 40.36"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M44.8999 29.2796C43.7313 28.9304 42.7324 28.1632 42.0936 27.1242C41.6302 26.275 41.4147 25.3127 41.4716 24.3469C41.7175 21.2947 44.8709 19.0526 48.5162 19.3564C52.1615 19.6601 54.9244 22.3652 54.6784 25.4173C54.576 26.373 54.216 27.2829 53.6369 28.05C53.2731 28.5541 52.7981 28.9676 52.2487 29.2586C51.6994 29.5496 51.0904 29.7102 50.469 29.728"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M52.1035 25.6488C52.1423 25.1458 52.0316 24.6425 51.7853 24.2022C51.5463 23.7743 51.1761 23.4345 50.7293 23.2331C50.2722 23.0357 49.7603 23.0049 49.2828 23.1463C48.8115 23.2837 48.3961 23.5673 48.0966 23.9563C47.9246 23.6402 47.6821 23.368 47.3878 23.1607C47.0992 22.9628 46.7664 22.8386 46.4187 22.7991C46.0708 22.7554 45.7176 22.8002 45.3916 22.9293C45.0446 23.0658 44.7336 23.2803 44.4828 23.5562C44.2319 23.8321 44.048 24.162 43.9451 24.5205C43.8585 24.8818 43.8585 25.2585 43.9451 25.6198C43.9947 25.9856 44.1338 26.3334 44.3501 26.6324C44.5438 26.9331 44.8132 27.1775 45.1312 27.3412C44.9141 27.7956 44.7817 28.2858 44.7407 28.7877C44.6246 29.6619 44.8358 30.548 45.3338 31.2758C45.5461 31.6488 45.8465 31.9642 46.2087 32.1946C46.5708 32.425 46.9838 32.5633 47.4117 32.5975C47.8396 32.6318 48.2693 32.5609 48.6635 32.391C49.0577 32.2211 49.4044 31.9575 49.6734 31.623C50.2895 30.9896 50.6456 30.1483 50.6715 29.2651C50.7096 28.779 50.6656 28.29 50.5413 27.8186C50.965 27.6578 51.3322 27.3761 51.5972 27.0085C51.8763 26.6272 52.0463 26.1772 52.0891 25.7066L52.1035 25.6488Z"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M46.5055 28.3827C46.7571 28.405 47.0097 28.352 47.2311 28.2302C47.4525 28.1085 47.6327 27.9237 47.7487 27.6992C47.8647 27.4748 47.9113 27.2209 47.8826 26.9699C47.8538 26.7189 47.751 26.4821 47.5873 26.2897C47.4235 26.0973 47.2063 25.958 46.9631 25.8895C46.7199 25.821 46.4618 25.8264 46.2217 25.905C45.9816 25.9836 45.7704 26.1319 45.6148 26.331C45.4593 26.5301 45.3665 26.771 45.3483 27.023C45.3344 27.1884 45.3534 27.3548 45.4041 27.5128C45.4549 27.6708 45.5364 27.8172 45.644 27.9436C45.7515 28.07 45.883 28.1739 46.0309 28.2492C46.1787 28.3246 46.34 28.3699 46.5055 28.3827V28.3827Z"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M49.0225 28.5997C49.2732 28.6188 49.5239 28.5633 49.7431 28.4401C49.9623 28.3169 50.14 28.1316 50.254 27.9075C50.368 27.6834 50.413 27.4306 50.3835 27.1809C50.354 26.9312 50.2511 26.6959 50.088 26.5045C49.9249 26.3132 49.7088 26.1745 49.4669 26.1059C49.225 26.0372 48.9682 26.0417 48.7289 26.1188C48.4896 26.196 48.2785 26.3422 48.1223 26.5392C47.966 26.7361 47.8715 26.9749 47.8508 27.2255C47.8369 27.3928 47.8563 27.5611 47.9078 27.7209C47.9593 27.8806 48.0418 28.0286 48.1507 28.1563C48.2596 28.2841 48.3927 28.389 48.5423 28.4651C48.6919 28.5412 48.8551 28.5869 49.0225 28.5997V28.5997Z"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M34.9361 17.3177L7.65002 28.855L21.2717 61.0707L48.5578 49.5334L34.9361 17.3177Z"
          fill={theme["colors"][colorScheme]["500"]}
          stroke={linesColor}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M31.6366 22.445L13.6102 30.067C12.7566 30.4279 12.3573 31.4125 12.7182 32.266L19.6642 48.6936C20.0251 49.5472 21.0097 49.9466 21.8632 49.5857L39.8896 41.9636C40.7432 41.6027 41.1426 40.6182 40.7817 39.7646L33.8356 23.337C33.4747 22.4834 32.4902 22.0841 31.6366 22.445Z"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M21.5383 55.2304L40.7772 47.1009"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M128.65 18.9069L98.2189 12.6325L90.8082 48.5751L121.24 54.8495L128.65 18.9069Z"
          fill={theme["colors"][colorScheme]["500"]}
          stroke={linesColor}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M122.578 21.3503L102.843 17.2814C101.787 17.0636 100.754 17.7433 100.536 18.7996L96.8351 36.7496C96.6174 37.8059 97.2971 38.8388 98.3534 39.0566L118.088 43.1255C119.145 43.3433 120.178 42.6636 120.395 41.6073L124.096 23.6573C124.314 22.601 123.634 21.5681 122.578 21.3503Z"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M94.5304 43.6581L115.997 48.0845"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M132.155 15.7979V16.2463C132.155 16.7389 132.275 17.2241 132.504 17.6601C132.733 18.096 133.065 18.4697 133.471 18.7488L133.833 18.9947C134.302 19.3145 134.671 19.7598 134.898 20.2797C135.126 20.7996 135.203 21.373 135.12 21.9344C135.037 22.4958 134.797 23.0225 134.429 23.4542C134.061 23.886 133.578 24.2054 133.037 24.3758L132.618 24.5205C132.147 24.6705 131.72 24.9335 131.375 25.2865C131.029 25.6396 130.776 26.0719 130.636 26.5456L130.52 26.9651C130.357 27.5071 130.046 27.9928 129.622 28.3675C129.198 28.7422 128.677 28.9909 128.12 29.0856C127.562 29.1804 126.988 29.1174 126.464 28.9037C125.94 28.6901 125.486 28.3343 125.154 27.8764L124.893 27.5148C124.603 27.1174 124.222 26.7955 123.781 26.5765C123.34 26.3574 122.854 26.2476 122.362 26.2563H121.913C121.348 26.2693 120.79 26.1242 120.303 25.8374C119.815 25.5505 119.417 25.1332 119.154 24.6326C118.891 24.1319 118.773 23.5677 118.813 23.0036C118.854 22.4394 119.05 21.8977 119.382 21.4394L119.657 21.0777C119.944 20.6793 120.131 20.2175 120.201 19.7314C120.272 19.2454 120.224 18.7495 120.062 18.2859L119.917 17.8664C119.731 17.3324 119.697 16.7569 119.82 16.2048C119.943 15.6527 120.217 15.1459 120.613 14.7414C121.008 14.3369 121.509 14.0509 122.058 13.9156C122.607 13.7802 123.183 13.8009 123.721 13.9753L124.141 14.1054C124.606 14.2632 125.103 14.3035 125.588 14.2227C126.072 14.142 126.529 13.9427 126.918 13.6426L127.28 13.3677C127.731 13.025 128.269 12.8154 128.833 12.7625C129.398 12.7096 129.965 12.8155 130.472 13.0683C130.979 13.3211 131.406 13.7107 131.703 14.1931C132 14.6754 132.157 15.2313 132.155 15.7979Z"
          fill={linesColor}
        />
        <path
          d="M91.6229 16.3476C75.4941 -7.4913 53.2319 8.39164 53.2319 8.39164"
          stroke={linesColor}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M83.4789 14.3947L91.8109 16.6513L92.8235 8.50735"
          stroke={linesColor}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M84.289 39.1594C79.6022 32.2305 74.2356 29.6267 69.3752 29.0337"
          stroke={linesColor}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M77.9531 37.6984L84.4336 39.4487L85.2147 33.1273"
          stroke={linesColor}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M106.305 34.0821C104.912 33.5624 103.772 32.5264 103.123 31.189C102.646 30.1337 102.471 28.9672 102.617 27.8186C103.166 24.1878 107.13 21.7865 111.455 22.4375C115.78 23.0884 118.861 26.589 118.311 30.2198C118.115 31.354 117.615 32.4139 116.865 33.2865C116.388 33.8544 115.79 34.307 115.113 34.6102C114.437 34.9134 113.7 35.0592 112.959 35.0368"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M115.216 30.35C115.304 29.7503 115.218 29.1381 114.97 28.5853C114.717 28.0462 114.296 27.6044 113.769 27.3268C113.257 27.0626 112.671 26.9809 112.106 27.0953C111.544 27.2325 111.038 27.5408 110.659 27.9777C110.475 27.5876 110.209 27.2421 109.878 26.9651C109.551 26.6988 109.162 26.5194 108.748 26.4435C108.333 26.3677 107.906 26.3978 107.506 26.5312C107.098 26.6598 106.726 26.8829 106.421 27.1821C106.112 27.4992 105.875 27.8791 105.727 28.2959C105.567 28.7153 105.508 29.166 105.553 29.6123C105.588 30.0531 105.727 30.4793 105.958 30.8563C106.171 31.2297 106.474 31.5432 106.84 31.7676C106.536 32.295 106.33 32.8734 106.233 33.4745C106.028 34.5103 106.208 35.5852 106.739 36.4978C106.996 36.9284 107.338 37.3028 107.743 37.5986C108.148 37.8943 108.609 38.1054 109.097 38.2192C109.597 38.2603 110.101 38.1981 110.576 38.0364C111.052 37.8746 111.489 37.6168 111.86 37.2789C112.662 36.5762 113.176 35.603 113.306 34.545C113.408 33.9465 113.408 33.3353 113.306 32.7368C113.825 32.5833 114.288 32.2816 114.637 31.8689C115.005 31.437 115.246 30.911 115.332 30.35H115.216Z"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M108.33 33.1563C108.631 33.2018 108.938 33.1572 109.213 33.0281C109.487 32.8989 109.718 32.691 109.874 32.4308C110.031 32.1706 110.107 31.8697 110.092 31.5664C110.077 31.263 109.973 30.9708 109.792 30.7269C109.611 30.483 109.362 30.2983 109.076 30.1962C108.79 30.0941 108.48 30.0793 108.185 30.1536C107.891 30.2279 107.625 30.3879 107.422 30.6135C107.218 30.839 107.087 31.1199 107.043 31.4204C106.985 31.8211 107.088 32.2285 107.329 32.5537C107.57 32.8789 107.93 33.0955 108.33 33.1563V33.1563Z"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M111.31 33.6192C111.61 33.6676 111.918 33.6256 112.195 33.4986C112.471 33.3715 112.704 33.1651 112.862 32.9055C113.021 32.646 113.099 32.3452 113.086 32.0412C113.074 31.7373 112.971 31.444 112.791 31.1987C112.611 30.9533 112.362 30.7671 112.076 30.6636C111.79 30.5601 111.48 30.544 111.184 30.6174C110.889 30.6908 110.622 30.8504 110.418 31.0758C110.214 31.3012 110.081 31.5823 110.037 31.8833C109.979 32.2819 110.08 32.6873 110.318 33.0122C110.556 33.337 110.912 33.555 111.31 33.6192V33.6192Z"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M29.8993 34.8198C30.1485 35.2304 30.3058 35.69 30.3606 36.1671C30.4153 36.6443 30.366 37.1276 30.2162 37.5839C30.0664 38.0402 29.8196 38.4587 29.4927 38.8106C29.1658 39.1624 28.7666 39.4393 28.3226 39.6223C26.6301 40.3311 23.766 39.521 23.7949 37.4091C23.7949 35.0223 23.6792 33.3299 25.3572 32.6211C27.0351 31.9123 28.5251 33.0261 29.8993 34.8198Z"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M27.7729 35.1525C27.7711 35.4302 27.7016 35.7033 27.5704 35.9481C27.5187 36.0852 27.439 36.2101 27.3364 36.3147C27.2338 36.4194 27.1106 36.5015 26.9745 36.5559C26.8384 36.6103 26.6926 36.6359 26.5461 36.6308C26.3996 36.6258 26.2558 36.5903 26.1238 36.5267C25.8584 36.4665 25.6137 36.3367 25.415 36.1506C24.9811 35.789 24.7786 35.355 26.1817 34.7041C27.5848 34.0531 27.7873 34.5884 27.7729 35.1525Z"
          fill={linesColor}
        />
        <path
          d="M29.5233 42.6745C29.5233 42.6745 32.8937 40.3745 33.588 37.7707C33.8833 36.8851 33.9431 35.938 33.7616 35.0223C33.587 34.1162 33.1666 33.2755 32.5465 32.5921C31.6786 31.6229 30.6371 30.6827 30.6371 30.6827C32.1559 28.5129 31.0566 27.6884 30.2754 27.2833C29.8993 27.0808 28.2792 26.4733 27.7006 29.3808L21.3503 32.0569C18.8623 30.4946 18.1535 32.0569 18.0378 32.4475C17.8208 33.2865 17.6328 34.6462 20.2365 35.0802C20.2365 35.0802 20.2365 36.5267 20.2365 37.7852C20.3229 38.6989 20.6416 39.5753 21.1623 40.3311C21.6916 41.0975 22.4088 41.7151 23.2453 42.1248C25.3428 43.3254 29.5233 42.6745 29.5233 42.6745Z"
          stroke={linesColor}
          strokeMiterlimit="10"
        />
        <path
          d="M124.691 23.1029H123.027L122.506 18.3438H123.953L124.141 20.2966C124.141 20.3979 124.141 20.6004 124.141 20.8173C124.141 21.0343 124.141 21.1501 124.141 21.4683C124.234 21.0793 124.355 20.6974 124.503 20.3255L125.399 18.3438H126.933L124.691 23.1029Z"
          fill={theme["colors"][colorScheme]["500"]}
        />
        <path
          d="M130.954 21.9601L130.708 23.1029H126.629C126.715 22.5453 126.962 22.0251 127.34 21.6062C127.718 21.1873 128.21 20.8879 128.755 20.745C129.754 20.2966 129.985 20.123 129.985 19.8192C129.985 19.5155 129.768 19.4287 129.464 19.4287C129.16 19.4287 128.755 19.7325 128.712 20.2532H127.266C127.302 19.7655 127.477 19.2984 127.772 18.9079C128.02 18.6681 128.315 18.4825 128.639 18.363C128.963 18.2435 129.308 18.1926 129.652 18.2136C130.752 18.2136 131.403 18.7344 131.403 19.6601C131.4 19.9102 131.34 20.1563 131.227 20.3795C131.114 20.6027 130.951 20.7971 130.752 20.9475C130.343 21.2487 129.889 21.483 129.406 21.6419C129.123 21.731 128.852 21.8524 128.596 22.0035L130.954 21.9601Z"
          fill={theme["colors"][colorScheme]["500"]}
        />
      </g>
      <defs>
        <clipPath id="incentivesClipPath">
          <rect
            width="144.899"
            height="61.55"
            fill="white"
            transform="translate(0.100708 0.725006)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IncentivesIllustration;
